export const parsedOption = (data: any) => {
  let map: any[] = [];
  data.map((supplier: any) => {
    let newObj = {
      label: supplier.id + " - " + supplier.name,
      value: supplier.id,
    };
    map.push(newObj);
  });
  return map;
};
